import { ofType } from 'redux-observable'
import * as actions from './actions'
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators'
import { headersSelector } from '../../auth/selectors'
import Config from '../../../config/Config'
import { ajax } from 'rxjs/ajax'
import { of } from 'rxjs'
import queryString from '@promoboxx/query-string-babel'

const buildLocationParams = (payload) => {
  const { fields } = payload

  let params = queryString.stringify(
    {
      fields,
    },
    { arrayFormat: 'bracket' },
  )
  if (params) {
    params = `?${params}`
  }
  return params
}

/**
 * @typedef GetLocationsByRetailerPayload
 * @property {number} retailerId
 * @property {string[]} [fields]
 */

/**
 * Get locations by retailer
 * @link http://api.promoboxx.com/docs/V2/locations/index.html
 */
export const getLocationsByRetailer = (action$, state$) => {
  return action$.pipe(
    ofType(actions.GET_LOCATIONS_BY_RETAILER),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const headers = headersSelector(state)
      const { retailerId } = action.payload

      if (!headers) {
        throw new Error('Bad or Non-existent auth headers')
      }
      if (!retailerId) {
        throw new Error('payload.retailerId is required')
      }

      const params = buildLocationParams(action.payload)

      const settings = {
        method: 'GET',
        responseType: 'json',
        headers,
        url: `${Config.API_BASE}/v2/retailer/${retailerId}/locations${params}`,
      }
      return ajax(settings).pipe(
        map((payload) => {
          return {
            type: actions.GET_LOCATIONS_BY_RETAILER_FULFILLED,
            payload: {
              response: payload.response,
              request: action.payload,
            },
          }
        }),
        catchError((payload) => {
          return of({
            type: actions.GET_LOCATIONS_BY_RETAILER_REJECTED,
            payload: {
              response: payload.response,
              request: action.payload,
            },
          })
        }),
      )
    }),
    catchError((payload) => {
      return of({
        type: actions.GET_LOCATIONS_BY_RETAILER_REJECTED,
        payload,
      })
    }),
  )
}
